<template>
  <div>
    <div ref="register_selector">
      <BaseSelectorField
        v-model="query_params.search"
        :multiple="multiple"
        :selectedItems="selectedItems"
        :objectName="multiple ? null : selectedItems[0]?.name"
        :placeholder="disabled ? placeholder || null : `Select ${!multiple ? modelName.singular : modelName.plural}`"
        :inputClasses="inputClasses"
        :label="label"
        :disabled="disabled"
        :validation="validation"
        :hasWarning="hasWarning"
        :warningMessage="warningMessage"
        :hideMessage="hideMessage"
        :loading="loading || addLoading"
        :searching="searching"
        :required="required"
        :isVoid="isVoid"
        @open-dialog="openModal"
        @clear-selection="clearSelection"
        @focus="handleFieldFocus"
        @blur="handleFieldBlur"
        @query="query"
        @remove-item="removeItem"
        tabindex="1"
      />

      <BaseDialogSelectorList
        displayName="name"
        matchKey="id"
        :open="listVisible"
        :items="query_data?.results"
        :target="$refs.register_selector"
        :searching="searching"
        :selectedItems="selectedItems"
        :modelName="modelName"
        :enableNew="false"
        @selected="selectItem"
        @create="create"
        @clear="clearSelection"
        @update:open="listVisible = $event"
      >
      </BaseDialogSelectorList>
    </div>

    <BaseSelectorDialog 
      v-model="query_params.search" 
      ref="dialog" 
      :modelName="modelName" 
      :loading="addLoading"
      @openNew="openNew"
      @open="dialogOpen = true"
      @close="dialogOpen = false"
      disableQuickAdd
    >
      <template #filters>
        <slot name="filters">
          <BaseLocationDialogSelector v-model="query_params.location" disableAdd disableModals disableQuickAdd />
        </slot>
      </template>

      <template #table>
        <BaseTable
          ref="table"
          :selectMode="multiple ? 'multi' : 'single'"
          :data_="query_data"
          :fields="fields"
          :selected.sync="selectedItems"
          :defaultPageSize="query_params.page_size"
          :modelName="modelName"
          :loading="queryLoading"
          @page_change="query_params.page = $event"
          @page_size_change="query_params.page_size = $event"
          @ordering_change="query_params.ordering = $event"
          @selected="() => { if (!multiple) $refs.dialog.hide() }"
          :rowClickable="!multiple"
        />
      </template>
    </BaseSelectorDialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import BaseDialogSelector from "@/components/shared/BaseDialogSelectors/BaseDialogSelector.vue";
import BaseLocationDialogSelector from "@/components/shared/BaseDialogSelectors/BaseLocationDialogSelector.vue";

export default {
  extends: BaseDialogSelector,
  components: {
    BaseLocationDialogSelector,
  },
  props: {
    label: { type: String, default: "Register", },
    placeholder: { type: String, default: null, },
    location: { type: Object, default: null, },
  },
  data() {
    return {
      fields: [
        { key: "name", sortable: true },
        { key: "location.name", label: "Location" },
      ],
      modelName: { singular: "Register", plural: "Registers" },
    };
  },
  methods: {
    ...mapActions("registers", ["fetchRegisters"]),

    openNew() {
      const url = this.$router.resolve("/settings/registers/").href;
      window.open(url, "_blank");
    },

    query() {
      this.queryLoading = true;
      this.searching = true;
      this.fetchRegisters({
          ...this.query_params,
          location: this.location,
      }).then((res) => {
          this.query_data = res.data;
      }).finally(() => {
        this.queryLoading = false;
        this.searching = false;
      });
    },
  },
};
</script>